import http from './http'
import { getToken } from './auth'

const base = 'route-plans'
const authed = () => ({ headers: { 'Authorization': 'Bearer ' + getToken() } })

// Calendar day as YYYY-MM-DD in the viewer's local time — a route belongs to
// a day, so it must never shift with the timezone the way toISOString() would.
export const toRouteDate = (d = new Date()) => {
    const x = new Date(d)
    const pad = (n) => String(n).padStart(2, '0')
    return `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}`
}

export async function getRoutePlans(date) {
    const { data } = await http.get(base, { ...authed(), params: { date } })
    return data
}

export async function getRoutePlan(id) {
    const { data } = await http.get(`${base}/${id}`, authed())
    return data
}

// { date, name?, driverId?, stops: [{ jobId, activity }] }
export async function createRoutePlan(payload) {
    const { data } = await http.post(base, payload, authed())
    return data
}

// { id, name?, driverId?, date?, stops? } — stops, when given, replace the order.
export async function updateRoutePlan({ id, ...payload }) {
    const { data } = await http.patch(`${base}/${id}`, payload, authed())
    return data
}

export async function addRouteStops({ id, stops }) {
    const { data } = await http.post(`${base}/${id}/stops`, { stops }, authed())
    return data
}

// { id, stopId, status: PENDING|DONE|CUSTOMER_UNAVAILABLE|SKIPPED, note? } — returns the whole plan.
export async function updateRouteStop({ id, stopId, ...payload }) {
    const { data } = await http.patch(`${base}/${id}/stops/${stopId}`, payload, authed())
    return data
}

export async function deleteRoutePlan(id) {
    const { data } = await http.delete(`${base}/${id}`, authed())
    return data
}
